/* Grid product cards (snippets/home-product-card.liquid with grid: true): swatches, ship day, label fit, row labels.
   Loaded (defer) from layout/theme.liquid on the home page, the About page and collection pages, before home.js
   and the collection section's collection-filters.js.
   A card group is any element marked data-card-group that holds the cards' <li>s: the collection #product-grid and
   each home row's .wwl__track. Each group carries the ship data from snippets/card-ship-data.liquid.
   - Swatches (.hc-sw, delegated from document): switch the card's link, photo (src/srcset/alt) and price to that
     colour, no navigation.
   - Ship day: [data-shipday] = data-today before the group's data-cutoff hour on a shipping day in data-tz, otherwise
     the next shipping day (data-tomorrow, or data-weekday with the weekday name for __day__). A shipping day is a
     data-days weekday whose store date is not in data-holidays (YYYY-MM-DD list; bad or missing = none). The data is
     read from the card's closest [data-card-group].
   - Label fit: the group gets .is-stacked when any .hc-label doesn't fit beside its brand.
   - Row labels: right after every label fit, cards in a visual row (same offsetTop; a scrolling track is one row)
     where no .hc-label has text get .hc-card--nolabel-row, which drops the reserved label line.
   Runs on load, after fonts load, when a group's width changes, every 5 minutes and when the tab is shown again.
   window.cfsCards.refresh(root) re-runs all three on the groups in root (or root itself, or the whole page) and
   watches their width; call it after inserting cards (collection-filters.js after swaps and Load more, home.js after
   the Recently Viewed swap). */
(() => {
  const GROUP = '[data-card-group]';
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const cards = (g) => $$(':scope > li.hc-card', g);

  function groups(root) {
    if (!root || root === document) return $$(GROUP);
    const list = root.matches && root.matches(GROUP) ? [root] : [];
    return list.concat($$(GROUP, root));
  }

  // Swatch: switch the card's link, photo and price to that colour (no navigation)
  function pickSwatch(btn) {
    const card = btn.closest('.hc-card');
    if (!card) return;
    $$('.hc-sw', card).forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
    const d = btn.dataset;
    const link = $('.hc-card__link', card);
    if (link && d.url) link.setAttribute('href', d.url);
    const img = $('.hc-img img', card);
    if (img && d.src) {
      img.srcset = d.srcset || '';
      img.src = d.src;
      if (d.alt) img.alt = d.alt;
    }
    const price = $('.hc-price', card);
    if (price && d.price) price.textContent = d.price;
  }

  // Ship day in the store's timezone: today before the cutoff on a shipping day, else the next shipping day.
  // A shipping day is a data-days weekday whose store date (YYYY-MM-DD) is not in data-holidays. Dates are UTC
  // midnights of the store's calendar date, so stepping a day never trips over DST.
  const WEEK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const WEEK_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function shipText(g) {
    const d = g.dataset;
    let days = [];
    try { days = JSON.parse(d.days || '[]').map((s) => String(s).trim()); } catch (e) { return ''; }
    let holidays = [];
    try { holidays = JSON.parse(d.holidays || '[]').map((s) => String(s).trim()); } catch (e) { holidays = []; }
    const cutoff = parseInt(d.cutoff, 10);
    if (!days.length || isNaN(cutoff) || !d.tz) return '';
    let parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: d.tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    } catch (e) { return ''; }
    const get = (t) => parseInt((parts.find((p) => p.type === t) || {}).value, 10);
    const hour = get('hour') % 24;
    const y = get('year'), m = get('month'), day = get('day');
    if ([hour, y, m, day].some(isNaN)) return '';
    const isShipDay = (dt) => days.indexOf(WEEK[dt.getUTCDay()]) !== -1 && holidays.indexOf(dt.toISOString().slice(0, 10)) === -1;
    const today = new Date(Date.UTC(y, m - 1, day));
    if (isShipDay(today) && hour < cutoff) return d.today || '';
    for (let k = 1; k <= 31; k++) {
      const dt = new Date(Date.UTC(y, m - 1, day + k));
      if (isShipDay(dt)) return k === 1 ? (d.tomorrow || '') : (d.weekday || '').replace('__day__', WEEK_LONG[dt.getUTCDay()]);
    }
    return '';
  }

  // Each ship day is painted from its own card's closest group
  function paintShip(g) {
    const text = shipText(g);
    $$('[data-shipday]', g).forEach((el) => {
      if (el.closest(GROUP) !== g) return;
      if (el.textContent !== text) el.textContent = text;
    });
  }

  // Label fit: stack every label under its brand when any label doesn't fit beside it
  function fitLabels(g) {
    g.classList.remove('is-stacked');
    const clash = $$('.hc-label', g).some((l) => l.textContent.trim() !== '' && l.scrollWidth > l.clientWidth + 1);
    if (clash) g.classList.add('is-stacked');
  }

  // Row labels: cards in a visual row (same offsetTop) with no label text drop the reserved label line.
  // All rows are measured before any class changes; the columns don't change, so rows keep their cards.
  function rowLabels(g) {
    const rows = new Map();
    cards(g).forEach((li) => {
      const top = Math.round(li.offsetTop);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(li);
    });
    rows.forEach((row) => {
      const empty = !row.some((li) => $$('.hc-label', li).some((l) => l.textContent.trim() !== ''));
      row.forEach((li) => li.classList.toggle('hc-card--nolabel-row', empty));
    });
  }

  function fitRows(g) {
    fitLabels(g);
    rowLabels(g);
  }

  // Only width changes refit, so stacking (which changes the group's height) can't loop
  const widths = new WeakMap();
  const watched = new Set();
  const resizer = 'ResizeObserver' in window ? new ResizeObserver((entries) => {
    entries.forEach((en) => {
      const w = Math.round(en.contentRect.width);
      if (widths.get(en.target) === w) return;
      widths.set(en.target, w);
      if (en.target.isConnected) fitRows(en.target);
    });
  }) : null;

  function watch(list) {
    if (!resizer) return;
    // Groups replaced by a swap are no longer in the page: stop watching them
    watched.forEach((g) => { if (!g.isConnected) { resizer.unobserve(g); watched.delete(g); } });
    list.forEach((g) => { if (!watched.has(g)) { watched.add(g); resizer.observe(g); } });
  }

  function refresh(root) {
    const list = groups(root);
    list.forEach((g) => {
      paintShip(g);
      fitRows(g);
    });
    watch(list);
  }

  window.cfsCards = { refresh };

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    const sw = t && t.closest('.hc-sw');
    if (sw) pickSwatch(sw);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh());
  else refresh();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => refresh());
  setInterval(() => refresh(), 5 * 60 * 1000);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(); });
})();
